import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';
export const claimGroupsService = {
  all: function (companyId) {
    let queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return fetch("/api/time_tracking/companies/".concat(companyId, "/claim_groups?").concat(queryParams), request.get);
  }
};